import { ApiFunc, getInstance } from '@src/helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const colorPalette: ApiFunc<`${typeof API.COLOR_PALETTE}`, 'get'> = data =>
  instance.get(API.COLOR_PALETTE, { params: data })
